import { Button } from "../Button";
import { RoomCard } from "./RoomCard";
import type { RoomInfo } from "../../types/game";

interface RoomsGridProps {
  rooms: RoomInfo[];
  canRejoinRoom: (room: RoomInfo) => boolean;
  onRejoin: (room: RoomInfo) => void;
  onJoin: (room: RoomInfo) => void;
  onSpectate: (room: RoomInfo) => void;
  onDeleteRoom: (sessionId: string) => void;
  onCreateRoom: () => void;
  advancedMode: boolean;
  isAdmin: boolean;
}

export function RoomsGrid({
  rooms,
  canRejoinRoom,
  onRejoin,
  onJoin,
  onSpectate,
  onDeleteRoom,
  onCreateRoom,
  advancedMode,
  isAdmin,
}: RoomsGridProps) {
  if (rooms.length === 0) {
    return (
      <div className="text-center py-12" data-testid="home-no-rooms-message">
        <p className="text-gray-400 mb-4 text-lg">No active rooms found</p>
        <p className="text-sm text-gray-500 mb-6">
          Be the first to create a room and start playing!
        </p>
        <Button
          onClick={onCreateRoom}
          variant="success"
          className="inline-block"
          data-testid="home-create-room-button"
        >
          ➕ Create New Room
        </Button>
      </div>
    );
  }

  return (
    <div
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
      data-testid="home-rooms-grid"
    >
      {rooms.map((room) => (
        <RoomCard
          key={room.session_id}
          room={room}
          canRejoin={canRejoinRoom(room)}
          onRejoin={() => onRejoin(room)}
          onJoin={() => onJoin(room)}
          onSpectate={() => onSpectate(room)}
          advancedMode={advancedMode}
          isAdmin={isAdmin}
          onDeleteRoom={() => onDeleteRoom(room.session_id)}
        />
      ))}
    </div>
  );
}
